type SmallLoaderProps = {
    text?: string,
    iconColor?: string,
    className?: string
}

export default function SmallLoader({ text, iconColor = "white", className }: SmallLoaderProps) {
    return (
        <div className="small-loader-div">
            <span className={'spinner-border spinner-border-sm me-2 small-loader' + (className ? ` ${className}` : '')} style={{ color: iconColor }} role="status" aria-hidden="true"></span>
            {text && <span>{text}</span>}
        </div>
    )
}
